// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manifest } from './manifest';
import { ManifestGroupInvoice } from './manifest-group-invoice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManifestGroup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK manifest */
  manifestId!: number;
  /** DateTime */
  sentDate?: Date;
  /** FK manifestId */
  manifest!: Manifest;
  /** Inv FK manifestGroupId */
  manifestGroupInvoices!: ManifestGroupInvoice[];
}

